import React from 'react';
import { FlexContainer, ShimmerTypography, Space } from '@pitchero/react-ui';

const VideoDetailLoading = () => (
  <>
    <ShimmerTypography preset="subtitle--large" width="60%" />
    <Space vertical="small">
      <FlexContainer direction="row" justifyContent="space-between">
        <ShimmerTypography preset="name" width="30%" />
        <ShimmerTypography preset="body--small-opacity" width="10%" />
      </FlexContainer>
    </Space>
    <ShimmerTypography preset="body--small" width="100%" />
    <ShimmerTypography preset="body--small" width="100%" />
    <ShimmerTypography preset="body--small" width="100%" />
    <ShimmerTypography preset="body--small" width="20%" />
  </>
);

export default VideoDetailLoading;
